import * as React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, {stepConnectorClasses} from '@mui/material/StepConnector';

import {useFunctionQuery} from '../atoms/withMediaQuery';
import CommonTheme from '../../Theme';
const palette = CommonTheme.palette.primary;

const ColorLibConnector = styled(StepConnector)(({theme}) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 20,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: palette.light,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: palette.light,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor: palette.light,
  },
}));

const StepIconRoot = styled('div')(({theme, ownerState}) => ({
  'color': palette.light,
  'display': 'flex',
  'height': 40,
  'alignItems': 'center',
  ...(ownerState.active && {
    color: palette.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: palette.main,
    zIndex: 1,
  },
  '& .QontoStepIcon-circle': {
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'currentColor',
    zIndex: 2,
  },
}));

const orderSteps = [
  {key: 'stepper1', name: '申込作成', step: '1', validStatus: []},
  {key: 'stepper2', name: '受付', step: '2', validStatus: []},
  {key: 'stepper3', name: '技術検討', step: '3', validStatus: []},
  {key: 'stepper4', name: '改修設計', step: '4', validStatus: []},
  {key: 'stepper5', name: '共架申込', step: '5', validStatus: []},
  {key: 'stepper6', name: '共架承認', step: '6', validStatus: []},
  {key: 'stepper7', name: '改修工事', step: '7', validStatus: []},
  {key: 'stepper8', name: 'しゅん工', step: '8', validStatus: []},
  {key: 'stepper9', name: '施設確認', step: '9', validStatus: []},
  {key: 'stepper10', name: '完結', step: '10', validStatus: []},
];
const koziSteps = [
  {key: 'stepper1', name: '工事依頼', step: '1', validStatus: []},
  {key: 'stepper2', name: '工事計画', step: '2', validStatus: []},
  {key: 'stepper3', name: '工事実施', step: '3', validStatus: []},
  {key: 'stepper4', name: '工事完了', step: '4', validStatus: []},
];
const henkoSteps = [
  {key: 'stepper1', name: '変更連絡票 発行／編集', step: '1', validStatus: []},
  {key: 'stepper2', name: '変更連絡(事前)', step: '2', validStatus: []},
  {key: 'stepper3', name: '変更連絡票編集', step: '3', validStatus: []},
  {key: 'stepper4', name: '変更連絡(本)', step: '4', validStatus: []},
  {key: 'stepper5', name: '移設予定登録', step: '5', validStatus: []},
  {key: 'stepper6', name: '移設結果登録', step: '6', validStatus: []},
  {key: 'stepper7', name: '完結', step: '7', validStatus: []},
];

const kaisyuTutiSteps =[
  {key: 'stepper1', name: '改修通知発行／登録', step: '1', validStatus: []},
  {key: 'stepper2', name: '通知受理', step: '2', validStatus: []},
  {key: 'stepper3', name: '通知受理（協議済）', step: '3', validStatus: []},
  {key: 'stepper4', name: '改修設計依頼中', step: '4', validStatus: []},
  {key: 'stepper5', name: '改修工事依頼中', step: '5', validStatus: []},
  {key: 'stepper6', name: '改修工事', step: '6', validStatus: []},
  {key: 'stepper7', name: '完結', step: '7', validStatus: []},
];

const kyogatyuTorokuSteps =[
  {key: 'stepper1', name: '作成中', step: '0', validStatus: []},
  {key: 'stepper2', name: '共架柱登録申請中', step: '1', validStatus: []},
  {key: 'stepper3', name: '共架者未確認', step: '2', validStatus: []},
  {key: 'stepper4', name: '共架者確認申請中', step: '3', validStatus: []},
  {key: 'stepper5', name: '完結', step: '4', validStatus: []},
];

const nttOrderSteps =[
  {key: 'stepper1', name: '申込', step: '0', validStatus: []},
  {key: 'stepper2', name: '受理', step: '1', validStatus: []},
  {key: 'stepper3', name: 'しゅん工', step: '2', validStatus: []},
  {key: 'stepper4', name: '完結', step: '3', validStatus: []},
];

function CustomStepIcon(props) {
  const {active} = props;
  return (
    <StepIconRoot ownerState={{active}}>
      <div className="QontoStepIcon-circle" />
    </StepIconRoot>
  );
}

/**
 * ステッパー表示
 * @param {string} status 申込ステータス
 * @param {string} category '1': 共架申込, '2': 改修工事, '3': 変更連絡, '4': 改修通知, '5': 共架柱登録, '6': 共架申込（NTT）
 * @param {array} genericStatus 汎用マスタの申込ステータス
 * @return {*} ステッパー
 */
export default function CustomStepper({status='01', category='1', genericStatus=[]}) {
  const isMobile = useFunctionQuery();
  if (isMobile) {
    return <></>;
  }
  function setValidStatus(steps) {
    let statusList = [];
    for (const data of steps) {
      let newData = {...data};
      let key = 'valueString2';
      if (category === '6') {
        key = 'valueString1';
      }
      const results = genericStatus.filter(
          (status) => category === '5' ?
          status.cdName == data.name :
          status[key] == data.name)
          .map((status) => status.cd);
      newData.validStatus = results;
      statusList.push(newData);
    }
    return statusList;
  }

  let statusList = [];
  if (category === '2') {
    statusList = setValidStatus(koziSteps);
  } else if (category === '3') {
    statusList = setValidStatus(henkoSteps);
  } else if (category === '4') {
    statusList = setValidStatus(kaisyuTutiSteps);
  } else if (category === '5') {
    statusList = setValidStatus(kyogatyuTorokuSteps);
  } else if (category === '6') {
    statusList = setValidStatus(nttOrderSteps);
  } else {
    statusList = setValidStatus(orderSteps);
  }
  let activeStep = -1;
  for (let index = 0; index < statusList.length; index++) {
    const element = statusList[index];
    const valid = element.validStatus.indexOf(status);
    if (valid != -1) {
      activeStep = index;
      break;
    }
  }
  return (
    <Box sx={{width: '100%', overflow: 'hidden'}}>
      <Stepper activeStep={activeStep} sx={{flexDirection: 'row', flexWrap: 'wrap'}}
        connector={<ColorLibConnector />} alternativeLabel>
        {statusList.map((label) => (
          <Step key={label.key}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              {label.name}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
};

CustomStepper.propTypes = {
  status: PropTypes.string,
  category: PropTypes.string,
  genericStatus: PropTypes.array,
};
